import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { DetailedIconPiggybank, DetailedIconHome } from '@zillow/constellation';
import { AFFORDABILITY_DTI_MAX } from '../AffordabilityCalculator.utils.js';

var AFFORDABILITY_IMG_MIN = 40;
var AFFORDABILITY_IMG_MAX = 100;
var AFFORDABILITY_SIZE = AFFORDABILITY_IMG_MAX - AFFORDABILITY_IMG_MIN;
var StyledAffordabilityGraphicImagesContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-19xz5ow-0"
})(["min-height:100px;position:relative;margin-bottom:5px;"]);
var StyledAffordabilityGraphic = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-19xz5ow-1"
})(["position:absolute;bottom:0;svg{width:", "px;height:", "px;max-height:100px;max-width:100px;}"], function (props) {
  return props.width;
}, function (props) {
  return props.height;
});
var StyledAffordabilityGraphicPiggy = /*#__PURE__*/styled(StyledAffordabilityGraphic).withConfig({
  componentId: "sc-19xz5ow-2"
})(["left:20px;"]);
var StyledAffordabilityGraphicHouse = /*#__PURE__*/styled(StyledAffordabilityGraphic).withConfig({
  componentId: "sc-19xz5ow-3"
})(["right:20px;"]);
function getImageRatios(_ref) {
  var customPayment = _ref.customPayment,
    monthlyPayment = _ref.monthlyPayment,
    maximumPayment = _ref.maximumPayment,
    dti = _ref.dti;
  var ratio;
  if (customPayment) {
    ratio = monthlyPayment / maximumPayment;
  } else {
    ratio = dti / AFFORDABILITY_DTI_MAX;
  }
  var big = AFFORDABILITY_IMG_MIN + AFFORDABILITY_SIZE * ratio;
  var small = AFFORDABILITY_IMG_MAX - AFFORDABILITY_SIZE * ratio;
  return {
    big: big,
    small: small
  };
}
function AffordabilityGraphic(_ref2) {
  var customPayment = _ref2.customPayment,
    monthlyPayment = _ref2.monthlyPayment,
    maximumPayment = _ref2.maximumPayment,
    dti = _ref2.dti;
  var imageRatios = getImageRatios({
    customPayment: customPayment,
    monthlyPayment: monthlyPayment,
    maximumPayment: maximumPayment,
    dti: dti
  });
  return /*#__PURE__*/React.createElement(StyledAffordabilityGraphicImagesContainer, null, /*#__PURE__*/React.createElement(StyledAffordabilityGraphicPiggy, {
    width: imageRatios.small,
    height: imageRatios.small
  }, /*#__PURE__*/React.createElement(DetailedIconPiggybank, {
    alt: "piggy bank"
  })), /*#__PURE__*/React.createElement(StyledAffordabilityGraphicHouse, {
    width: imageRatios.big,
    height: imageRatios.big
  }, /*#__PURE__*/React.createElement(DetailedIconHome, {
    alt: "house"
  })));
}
AffordabilityGraphic.propTypes = process.env.NODE_ENV !== "production" ? {
  customPayment: PropTypes.number,
  monthlyPayment: PropTypes.number,
  maximumPayment: PropTypes.number,
  dti: PropTypes.number
} : {};

export { AffordabilityGraphic as default };
